import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private url: string = environment.url;
  constructor(private http: HttpClient) { }

  get(url: string) {
    return this.http.get(url, { responseType: 'blob' }).toPromise();
  }

  avatar(path: string): string {
    return `${this.url}/picture/users/${path}`;
  }
}
